import React from 'react';

import moment from 'moment';

import { useSelector } from 'react-redux';
import t from 'react-translate';

// schemas
import { RootState } from 'redux/schemas';
import { ActivityType } from 'redux/schemas/models/activity';
import { ComponentKeyPluralized } from 'redux/schemas/models/lecture-component';

// actions
import { setActivityExpandedInAutomatedCommunications } from 'redux/actions/course-communications';

// selectors
import { isActivityExpandedInAutomatedCommunications } from 'redux/selectors/course-communications';

// components
import NvIcon from 'shared/components/nv-icon';
import NvStackedTab from 'shared/components/nv-stacked-tab';

import CommunicationCreateNewDropdown from 'course_communications/components/communication-create-new-dropdown';
import CommunicationItem from 'course_communications/components/communication-item/communication-item';
import { useAppDispatch } from 'redux/store';
import NvTooltip from 'shared/components/nv-tooltip';
import { VideoPracticeFeedbackActivity } from 'redux/schemas/models/video-practice-feedback';
import { hasVideoPracticeFeedbackGotCommunicationError } from 'redux/selectors/timeline';

type VideoPracticeFeedbackLectureComponentProps = {
  practiceFeedbackActivityId: number
};

const VideoPracticeFeedbackActivityLectureComponent = (props: VideoPracticeFeedbackLectureComponentProps) => {
  const dispatch = useAppDispatch();

  const isExpanded = useSelector<RootState, boolean>((state) => isActivityExpandedInAutomatedCommunications(state, ComponentKeyPluralized.VIDEO_PRACTICE_FEEDBACK, props.practiceFeedbackActivityId));
  const practicefeedbackActivity = useSelector<RootState, VideoPracticeFeedbackActivity>((state) => state.models.practiceFeedbackActivities[props.practiceFeedbackActivityId]);

  const hasCommunicationError = useSelector<RootState, boolean>((state) => hasVideoPracticeFeedbackGotCommunicationError(state, props.practiceFeedbackActivityId));

  return (
    <React.Fragment>
      <div className={`lecture-component-row ${isExpanded && practicefeedbackActivity?.communicationsCount > 0 && 'expanded-box'}`}>
        <NvIcon icon='peer-feedback' size='smallest' />
        <div className='description'>{practicefeedbackActivity?.title}</div>
        {practicefeedbackActivity?.hasStructuralIssues && (
          <div className='text-danger spacing'>
            <NvIcon icon='warning' size='xss-smallest' />
          </div>
        )}
        {practicefeedbackActivity?.hardDeadline && (
          <NvTooltip text={t.TIMELINE.HARD_DEADLINE()} placement='top'>
            <div className='spacing'>
              <NvIcon icon='harddeadline' size='smallest' />
            </div>
          </NvTooltip>
        )}
        {practicefeedbackActivity?.deadline && (
          <div className='date'>
            {t.LECTURE_PAGES.COMPONENTS.DUE_DATE.STUDENT_VIEW(moment(practicefeedbackActivity.deadline).format('LLL'))}
          </div>
        )}
        <CommunicationCreateNewDropdown
          activityType={ActivityType.VIDEO_PRACTICE_FEEDBACK}
          activityId={props.practiceFeedbackActivityId}
        />
        {practicefeedbackActivity?.communicationsCount > 0 && (
          <NvStackedTab
            count={practicefeedbackActivity.communicationsCount}
            hasError={hasCommunicationError}
            isExpanded={isExpanded}
            errorMessage={t.COURSE_COMMUNICATIONS.WARNINGS.ACTIVITY_COMMUNICATION()}
            onClick={() => dispatch(setActivityExpandedInAutomatedCommunications({
              type: ComponentKeyPluralized.VIDEO_PRACTICE_FEEDBACK,
              id: props.practiceFeedbackActivityId,
              isExpanded: !isExpanded,
            }))}
          />
        )}
      </div>
      {
        // Communications
        isExpanded && practicefeedbackActivity?.communications && practicefeedbackActivity.communications?.map(communicationId => (
          <CommunicationItem key={communicationId.toString()} communicationId={communicationId} />
        ))
      }
    </React.Fragment>
  );
};

export default VideoPracticeFeedbackActivityLectureComponent;
